import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

const STATUS_ORDER = ["pending", "processing", "shipped", "out_for_delivery", "delivered"];

function StatusTimeline({ status }) {
    const idx = STATUS_ORDER.indexOf(status);
    return (
        <div className="grid grid-cols-5 gap-2 mt-4">
            {STATUS_ORDER.map((s, i) => (
                <div key={s} className="text-center">
                    <div className={`h-2 border-2 border-black ${i <= idx ? "bg-black" : "bg-white"}`} />
                    <div className="font-mono text-[9px] uppercase mt-2">{s.replace(/_/g, " ")}</div>
                </div>
            ))}
        </div>
    );
}

export default function OrderConfirmation() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    useEffect(() => { api.get(`/orders/${id}`).then(r => setOrder(r.data)); }, [id]);
    if (!order) return <div className="p-20 text-center font-mono">Loading…</div>;
    return (
        <div className="max-w-[900px] mx-auto px-4 md:px-10 py-10" data-testid="order-confirmation">
            <div className="font-mono text-[10px] uppercase text-[hsl(var(--accent))]">Confirmed</div>
            <h1 className="font-display text-5xl md:text-6xl tracking-tighter mt-1">Thanks for your order.</h1>
            <div className="font-mono text-xs uppercase text-neutral-500 mt-2">Order #{order.order_number}</div>

            <div className="mt-8 border-2 border-black p-6">
                <div className="font-mono text-xs uppercase tracking-widest">Status</div>
                <StatusTimeline status={order.status} />
                {order.tracking_url && <a href={order.tracking_url} target="_blank" rel="noreferrer" className="inline-block mt-4 underline font-mono text-xs">Track shipment →</a>}
            </div>

            <div className="mt-6 grid md:grid-cols-2 gap-6">
                <div className="border-2 border-black p-6">
                    <div className="font-mono text-xs uppercase mb-3">Items</div>
                    <div className="space-y-2">
                        {order.items.map((it, i) => (
                            <div key={i} className="flex justify-between font-mono text-xs">
                                <span>{it.name} × {it.quantity} ({it.size})</span>
                                <span>₹{Math.round(it.price * it.quantity)}</span>
                            </div>
                        ))}
                    </div>
                    <div className="mt-3 border-t-2 border-black pt-3 font-mono text-sm">
                        <div className="flex justify-between"><span>Subtotal</span><span>₹{Math.round(order.subtotal)}</span></div>
                        <div className="flex justify-between"><span>Discount</span><span>− ₹{Math.round(order.discount)}</span></div>
                        <div className="flex justify-between"><span>Shipping</span><span>₹{order.shipping}</span></div>
                        <div className="flex justify-between font-display text-xl mt-2"><span>Total</span><span>₹{Math.round(order.total)}</span></div>
                    </div>
                </div>
                <div className="border-2 border-black p-6">
                    <div className="font-mono text-xs uppercase mb-3">Shipping To</div>
                    <div className="text-sm">
                        <div className="font-medium">{order.address.full_name}</div>
                        <div className="text-neutral-600">{order.address.line1}</div>
                        {order.address.line2 && <div className="text-neutral-600">{order.address.line2}</div>}
                        <div className="text-neutral-600">{order.address.city}, {order.address.state} — {order.address.pincode}</div>
                        <div className="text-neutral-600">{order.address.country}</div>
                        <div className="text-neutral-600 mt-2 font-mono text-xs">Phone: {order.address.phone}</div>
                    </div>
                </div>
            </div>

            <div className="mt-8 flex gap-3">
                <Link to="/orders" className="font-mono text-xs uppercase px-4 py-3 border-2 border-black" data-testid="view-orders-btn">View All Orders</Link>
                <Link to="/shop" className="font-mono text-xs uppercase px-4 py-3 border-2 border-black bg-black text-white">Continue Shopping</Link>
            </div>
        </div>
    );
}
